import { clsx } from 'clsx';

type Mood = 'cheer' | 'apology' | 'lost' | 'farewell';

interface KokeMascotProps {
  mood?: Mood;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_CLASS: Record<NonNullable<KokeMascotProps['size']>, string> = {
  sm: 'w-16 h-16',
  md: 'w-24 h-24',
  lg: 'w-36 h-36 sm:w-44 sm:h-44',
};

const MOOD_LABEL: Record<Mood, string> = {
  cheer: '苔のキャラクター（応援）',
  apology: '苔のキャラクター（申し訳なさそうに見上げる）',
  lost: '苔のキャラクター（迷子）',
  farewell: '苔のキャラクター（お辞儀）',
};

export function KokeMascot({ mood = 'cheer', size = 'md', className }: KokeMascotProps) {
  return (
    <img
      src="/images/kokeoyako.png"
      alt={MOOD_LABEL[mood]}
      draggable={false}
      className={clsx(SIZE_CLASS[size], 'object-contain select-none', className)}
      style={{
        filter: 'drop-shadow(0 4px 8px rgba(126,143,112,0.25))',
      }}
    />
  );
}

export default KokeMascot;
